<shared-loader [hidden]="!showLoader"></shared-loader>
<div *ngIf="datosCargados; else loading">
    <div class="field col-12">
        @for (items of payload; track $index; ) {
            <b>
                <div class="text-900 font-semibold mb-3">{{ items.descripcion }} ({{ items.requisitos.length }})
                </div>
            </b>
            <!--Vista transaccional/carga de archivos segun proceso-->
            <div class="col-12 xs:col-5 sm:col-10 md:col-12 xl:col-12">
                <div class="grid">
                    <div *ngFor="let rq of items.requisitos" class="col-12 md:col-6 xl:col-4">
                        <div *ngIf="rq.reqType=='upload'">
                            <div
                                class="{{rq.idArchivoEstadoRq==1?'p-3':'p-2'}} border-1 surface-border flex align-items-center justify-content-between hover:surface-100 cursor-pointer border-round relative"
                                [pTooltip]="rq.fechaModificacion==null || rq.idArchivoEstadoRq!=1?'':'Fecha carga de archivo:  '+rq.fechaModificacion">
                                <div class="flex align-items-center">
                                    <i [ngClass]="rq.idArchivoEstadoRq==1?'pi pi-verified text-2xl pl-1':'pi pi-info-circle text-2xl pl-1'"
                                       [ngStyle]="{'color': rq.idArchivoEstadoRq==1?'green' : null}"
                                       [pTooltip]="rq.idArchivoEstadoRq==1?'Ya cumplió este requisito':'Requisito pendiente'"
                                       tooltipPosition="top"
                                       class="mr-3"></i>
                                    <span class="text-900">
                                    {{ rq.nombre }}
                                        <span *ngIf="!rq.opcional&&rq.idArchivoEstadoRq!=1" class="text-sm"
                                              [ngStyle]="{backgroundColor:'', color: 'var(--red-500)'}"> * Requerido *</span>
                                    <span *ngIf="rq.opcional&&rq.idArchivoEstadoRq!=1" class="text-sm"
                                          [ngStyle]="{backgroundColor: '', color: 'var(--blue-500)'}">(Opcional)</span>
                                    <p-progressBar
                                        *ngIf="this.progressBar[rq.idRequisito]<100"
                                        [value]="this.progressBar[rq.idRequisito]"
                                        [showValue]="true">
                                    </p-progressBar>
                                </span>
                                </div>
                                <div class="flex align-items-end" *ngIf="rq.idArchivoEstadoRq!=1">
                                    <div class="row m-2">
                                        <p-fileUpload
                                            #cargaArchivos
                                            [maxFileSize]="this.fileUtilsService.maxFileSize"
                                            id="cargaArchivos"
                                            customUpload="true"
                                            name="demo[]" class="mr-3"
                                            mode="basic"
                                            auto="true"
                                            chooseLabel=""
                                            tooltipPosition="top"
                                            styleClass="p-button-icon p-button-rounded p-button-outlined p-button-info"
                                            [pTooltip]="'Clic para seleccionar archivo'"
                                            (uploadHandler)="onFileUpload($event,cargaArchivos,rq.idRequisito)"
                                            [disabled]="showLoader||(rq.idArchivoEstadoRq==1||fileUtilsService.isIdRqInQueue(rq.idRequisito!))">
                                        </p-fileUpload>
                                    </div>
                                </div>
                                <!-- menu opciones-->
                                <div class="absolute top-0 right-0 ml-3">
                                    <p-menu #menu [model]="menuItems" [popup]="true" appendTo="body" styleClass="w-full md:w-15rem"></p-menu>
                                    <button
                                        class="p-button p-button-text md:h-3rem bg-transparent border-none shadow-none p-0"
                                        (click)="setRequisitos(rq);menu.toggle($event)"
                                        pTooltip="Opciones" [tooltipPosition]="'top'">
                                        <i class="pi pi-ellipsis-v text-xl"></i>
                                    </button>
                                </div>
                            </div>
                            <!--menssajes de errores-->
                            <div *ngIf="errorMessages[rq.idRequisito]">
                                <p-messages [(value)]="errorMessages[rq.idRequisito]" [enableService]="false"
                                            (onClose)="clearErrorMessage(rq.idRequisito)">
                                </p-messages>
                            </div>
                            <div class="flex align-items-center">
                                <p-button
                                    *ngIf="rq.idArchivoEstadoRq!=1&&fileUtilsService.isIdRqInQueue(rq.idRequisito!)"
                                    (onClick)="onFileQueueProcessItems(rq.idRequisito!)"
                                    [disabled]="showLoader"
                                    label="Subir"
                                    pTooltip="Inicia la subida de este archivo"
                                    icon="pi pi-cloud-upload"
                                    [rounded]="true" [outlined]="true"
                                    styleClass="p-button-icon p-button-info mr-1 pt-1 pb-1"/>
                                <p-button
                                    *ngIf="fileUtilsService.isIdRqInQueue(rq.idRequisito!)"
                                    (onClick)="fileUtilsService.removeItemFromQueue(rq.idRequisito)"
                                    [disabled]="showLoader"
                                    label="Remover"
                                    pTooltip="Remueve el archivo de la lista a subir"
                                    icon="pi pi-trash"
                                    [rounded]="true" [outlined]="true"
                                    styleClass="p-button-icon p-button-danger mr-1 pt-1 pb-1"/>
                            </div>
                        </div>
                        <rq-text *ngIf="rq.reqType=='text'"
                                 [rq]="rq"
                                 [onSubmitTemplate]="onSubmitTemplate"
                                 (onSubmitEmitter)="onSubmit($event)">
                            <ng-template #onSubmitTemplate let-item let-clickEvent="clickEvent">
                                <p-button icon="pi pi-check"
                                          *ngIf="rq.reqType=='text'&&rq.idArchivoEstadoRq!=1"
                                          styleClass="p-button-icon p-button-rounded p-button-outlined p-button-info p-button-sm p-md-button-lg p-lg-button-xl"
                                          (onClick)="clickEvent($event)"></p-button>
                            </ng-template>
                        </rq-text>
                        <rq-form *ngIf="rq.reqType=='form'"
                                 [rq]="rq"
                                 [onSubmitTemplate]="onSubmitTemplate"
                                 (onSubmitEmitter)="onSubmit($event)">
                            <ng-template #onSubmitTemplate let-item let-clickEvent="clickEvent"
                                         let-formInvalid="formInvalid">
                                <p-button icon="pi pi-check"
                                          label="Guardar cambios"
                                          type="button"
                                          [disabled]="formInvalid||rq.idArchivoEstadoRq == 1"
                                          class="w-full"
                                          styleClass="p-button-icon p-button-rounded p-button-outlined p-button-info p-button-sm p-md-button-lg p-lg-button-xl w-full"
                                          (onClick)="clickEvent($event)">
                                </p-button>
                            </ng-template>
                        </rq-form>

                    </div>
                </div>
            </div>
        }
    </div>
    <div class="col-12 xl:col-12">
        <div class="flex flex-column md:flex-row justify-content-between align-items-center mb-4">
            <div class="flex flex-column text-center md:text-left">

            </div>
            <span class="p-input-icon-right mt-2 mb-1">
             <p-button
                 *ngIf="fileUtilsService.fileQueue()&&fileUtilsService.fileQueue().length>0"
                 (onClick)="onFileQueueProcessItems()"
                 [disabled]="showLoader||fileUtilsService.fileQueue().length==0"
                 label="Subir todos ({{fileUtilsService.fileQueue().length}})"
                 pTooltip="Inicia la subida de todos los archivos"
                 icon="pi pi-cloud-upload"
                 size="large"
                 styleClass="p-button-rounded p-button-info mr-3"/>
            </span>
        </div>
    </div>
</div>

<ng-container *ngIf="dialogPdfView">
    <app-viewer-pdf [dialogPdfView]="dialogPdfView" [viewer]="viewer" [_showLoader]="true"
    (onPdfEmitterClose)="closeViewerPdf($event)"></app-viewer-pdf>
</ng-container>
<ng-container *ngIf="displayImgView">
    <app-viewer-img [_displayImgView]="displayImgView" [viewer]="viewer" [_showLoader]="true"
    (onImgtEmitterClose)="closeViewerImg($event)"></app-viewer-img>
</ng-container>
